<template>
  <div class="personal">
    <Nav @mobile="mobile" ref="nevRef" />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <!-- <div class="personal-bottom-top">
        <div class="personal-bottom-top-div">
          <div class="personal-bottom-top-div-div"></div>
          <span style="margin-left: 25px">个人中心</span>
        </div>
      </div> -->
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
           <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item class="xinxi" >
                <div class="title_box">
                  <span class="lines"></span>
                  <span>我的信息</span>
                </div>
                <span></span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div
              class="personal-bottom-bottom-right-bottom-top"
              v-if="personData.userInfo"
            >
              <div class="my_person_header">
                <img :src="personData.userInfo.avatar" alt="" />
              </div>
              <div class="person_top">
                <div class="person_name">
                  {{ personData.userInfo.nickname }}
                  <router-link to="xiugaipersonalc" class="router_edit" >
                    <img src="https://oss.ansongqiubo.com/assets/person/icon_bianji@2x.png" alt="">
                  </router-link >
                </div>
                <div class="person_id">
                  龙珠号:{{ personData.userInfo.account }}
                </div>

                <div class="bottom_progress">
                  <div class="home-top-longin-div-top-center">
                    <div class="home-top-longin-div-top-center-left">
                      LV.{{ personData.userInfo.level }}
                    </div>
                  </div>
                  <div class="home-top-longin-div-top-center-center">
                    <div class="jingyantiao">
                      <!-- ExpPercentage -->
                      <el-progress
                        :text-inside="true"
                        :stroke-width="6"
                        class="el-bg-inner-running"
                        :percentage="fifpercentage(personData.userInfo)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="home-top-longin-div-top-center-left">
                    LV.{{ personData.userInfo.level + 1 }}
                  </div>
                </div>

                <div
                  style="
                    margin-top: 5px;
                    color: #333;
                    font-size: 12px;
                    display: flex;
                    align-items: flex-start;
                  "
                >
                <span style="width: 90px;"> 个性签名：</span>

                  <span style="color: #696969; font-size: 12px">
                    {{ personData.userInfo.desc }}
                  </span>
                </div>
              </div>
            </div>
            <div class="personal-bottom-bottom-right-bottom-center1">
              <div class="title_box">
                <span class="lines"></span>
                <span>我的钱包</span>
              </div>
              <div class="person_money">
                <div class="person_money_item">
                  <div class="item_pays">
                    <img src="https://oss.ansongqiubo.com/assets/person/icon_longbi_da @2x.png" />
                    <span class="titles">我的龙币：</span
                    ><span class="price_item"
                      >{{
                        $store.state.userMoneyData? $store.state.userMoneyData.dragonCoin:0
                      }}龙币</span
                    >
                    <!-- hongbaodata.balance > 0 ? hongbaodata.balance : 0 -->
                  </div>
                  <div @click="Chongzhi" class="btn_intos">充值</div>
                </div>
                <div class="person_money_item">
                  <div class="item_pays">
                    <img src="https://oss.ansongqiubo.com/assets/person/icon_shouyi_mian@2x.png" />
                    <span class="titles">我的收益：</span>

                    <span
                      >{{
                        $store.state.userMoneyData? $store.state.userMoneyData.income:0
                      }}
                      元</span
                    >
                    <!--                         hongbaodata.income > 0 ? hongbaodata.income : 0 -->
                  </div>
                  <div @click="Tixian" class="btn_intos">提现</div>
                </div>
              </div>
            </div>
            <div class="personal-bottom-bottom-right-bottom-center2">
              <div class="title_box">
                <span class="lines"></span>
                <span>我的信息</span>
              </div>
              <div style="margin-top: 20px">
                <div class="userinfo_update">
                  <div class="number_list">
                    <div class="number_item">
                      <div class="phone_img">
                        <img
                          v-if="Mobile"
                          src="https://oss.ansongqiubo.com/assets/person/shouji_liang@2x.png"
                          alt=""
                        />
                        <img
                          v-else
                          src="https://oss.ansongqiubo.com/assets/person/shouji@2x.png"
                          alt=""
                        />
                      </div>
                      <div v-if="Mobile" class="items_tight">
                        <div class="phone_title">
                          手机号绑定({{ Mobile | fifphone }})账号
                        </div>
                        <div class="phone_number">
                          您可以享受与手机相关的提醒类服务
                        </div>
                      </div>
                      <div v-else class="nophone_item">
                        <span> 未绑定手机号 </span>
                      </div>
                    </div>
                    <router-link
                      :to="'/bangdingxinshoujihao?id=0&tab=0&mobile='+Mobile"
                      :class="Mobile ? 'over_updata' : ''"
                      class="update_phone"
                      >{{ !Mobile ? "绑定手机号" : "修改手机号" }}</router-link
                    >
                  </div>
                  <div class="number_list">
                    <div class="number_item">
                      <div class="phone_img">
                        <img
                          src="https://oss.ansongqiubo.com/assets/person/shouji_liang@2x.png"
                          alt=""
                        />
                      </div>
                      <div class="items_tight">
                        <div class="phone_title">密码安全 (高)</div>
                        <div class="phone_number">您当前密码安全指数较高</div>
                      </div>
                    </div>
                    <router-link :to="'/xiugaipassword?id=0&tab=0&mobile='+Mobile" class="update_phone"
                      >修改密码</router-link
                    >
                  </div>
                  <div class="number_list"  v-if="personData.userInfo">
                    <div class="number_item">
                      <div class="phone_img">
                        <img
                          v-if="centerStatus.idCardNo"
                          src="https://oss.ansongqiubo.com/assets/person/sfz_liang@2x.png"
                          alt=""
                        />
                        <img v-else src="https://oss.ansongqiubo.com/assets/person/sfz@2x.png" alt="" />
                      </div>
                      <div class="items_tight" v-if="personData.userInfo">
                        <div class="phone_title">身份认证</div>
                        <div v-if="personData.userInfo.identity ==2" class="phone_number">
                          您已经实名认证 {{centerStatus.idCardNo }}
                        </div>
                        <div v-else class="phone_number">
                          认证可开通直播
                        </div>
                      </div>
                    </div>
                    <div
                     @click="ToCenterStatus(personData.userInfo?personData.userInfo.identity:'')"
                      to="/bangdingidentity?id=0&tab=0"
                      :class="personData.userInfo.identity ==2? 'over_updata' : ''"
                      class="update_phone"
                      >{{
                       personData.userInfo.identity ==2 ? "已绑定" : "绑定身份证"
                      }}</div >
                  </div>
                  <div class="number_list">
                    <div class="number_item">
                      <div class="phone_img">
                        <img
                          v-if="shenfenData.bankCard"
                          src="https://oss.ansongqiubo.com/assets/person/yhk_liang@2x.png"
                          alt=""
                        />
                        <img v-else src="https://oss.ansongqiubo.com/assets/person/yhk@2x.png" alt="" />
                      </div>
                      <div class="items_tight">
                        <div class="phone_title">银行卡绑定</div>
                        <div v-if="shenfenData.bankCard" class="phone_number">
                          您已绑定银行卡 {{ shenfenData.bankCard }}
                        </div>
                        <div v-else class="phone_number">
                          绑定银行卡,便于获取直播收益
                        </div>
                      </div>
                    </div>
                    <router-link to="/bankc?id=0&tab=0" class="update_phone"
                      >绑定银行卡</router-link
                    >
                  </div>
                  <div class="number_list">
                    <div class="number_item">
                      <div class="phone_img">
                        <img
                          src="https://oss.ansongqiubo.com/assets/person/shouji_liang@2x.png"
                          alt=""
                        />
                      </div>
                      <div class="items_tight">
                        <div class="phone_title">实名认证</div>
                        <div class="phone_number">请前往APP进行身份认证</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Pay v-show="pay" :pay ="pay" :qrcode_url="qrcode_url" @pay='pays'></Pay> -->
    <!-- <Pay v-show="pay" :qrcode_url="qrcode_url" :pay ="pay" @pay='pays' :moneyData="hongbaodata"></Pay> -->
  </div>
</template>

<script>
import qs from "qs";
import Pay from "./Pay.vue";
import Nav from "./Nav.vue";
import slide from './template_slide.vue'
import {profilefinish} from '@/api/lz.js'
export default {
  name: "App",
  data() {
    return {
      b: 0,
      pay: false,
      token: "",
      personData: {},
      shenfenData: [],
      hongbaodata: [], //红包数据
      Mobile: "", //手机号
      qrcode_url: "",
      // aa:false
      activeName: 0,
      ExpPercentage: null, //经验条百分比
      centerStatus:{},
    };
  },
  filters: {
    fifphone(val) {
      if(!val){
        return ''
      }else{
        val  = String(val)
        let phone = val.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
        return phone;
      }

    }
  },
  created() {
    //页面加载时就从本地通过localstorage获取存储的token值
    this.token = localStorage.getItem("token");
  },
  mounted() {
    if( localStorage.getItem("token")){
      // 用户基本信息
      this.$store.dispatch('getUserInfoData').then((result) => {
        this.personData = result;
        this.ExpPercentage = Math.round(
          Math.round(
            (this.personData.userInfo.exp /
              this.personData.userInfo.nextLevelExp) *
              10000
          ) / 100.0
        );
       });

      // 获取完成状态

       profilefinish({

       }).then(res=>{
        console.log('个人中心完成',res);
        if(res.data.code == 200){
          this.centerStatus = res.data.data
        }
       })
      //   龙币收益余额
      this.$axios({
        url: this.api + "/v1/wallet/info",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //   console.log(res);
        this.hongbaodata = res.data.data;
      });

      // 获取身份证号
      this.$axios({
        url: this.api + "/v1/profile/bind",
        method: "GET",
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }).then((res) => {
        //   console.log(res);
        this.shenfenData = res.data.data;
      });
    }else{
      this.$router.replace('/')
    }

  },
  methods: {
    fifpercentage(item){
      if(item){
        return Number((item.exp / item.nextLevelExp) * 100)
      }
    },
    ToCenterStatus(v){
      if(v == 1){
        this.$router.push({
          path:'/anchor',
          query:{
            id:'0',
            tab:'0'
          }
        })
      }
    },
    changeSlide(data){
      this.$router.push(data);
    },
    mobile(e) {
      this.Mobile = e;
    },
    //   提现
    Tixian() {
      this.$router.push("/wodeshouyi");
    },
    pays(e) {
      this.pay = e;
    },
    Chongzhi() {
      this.$refs.nevRef.Pay();
    },
    dianji(e) {
      this.b = e;
    },
  },
  components: {
    Nav,
    slide,
    Pay,
  },
};
</script>

<style scoped lang='scss'>
.a {
  background-color: #721edc;
}
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .is-active {
  color: rgba(114, 30, 220, 1);
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  /* background-color: black; */
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}

.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
  }
}

.title_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .lines {
    display: inline-block;
    width: 4px;
    margin-right: 6px;
    border-radius: 4px;
    height: 20px;
    background: #721edc;
  }
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
}

.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 24px;
  }
}

.personal-bottom-bottom-right-bottom {
  background-color: #fff;
  box-sizing: border-box;
}

.personal-bottom-bottom-right-bottom-top {
  margin-top: 22px;
  padding-bottom: 26px;
  display: flex;
  border-bottom: 1px solid #dadada;
  .bottom_progress {
    display: flex;
    margin-top: 6px;
    align-items: center;
    .home-top-longin-div-top-center {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .home-top-longin-div-top-center-left {
      display: flex;
      background: #ffffff;
      // box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
      border-radius: 0px 0px 6px 6px;
      border-radius: 2px;
      text-align: center;
      /* border: 1px solid rgba(45, 143, 255, 1); */
      color: rgba(18, 115, 225, 1);
      font-size: 14px;
    }
  }
  .person_top {
    flex: 2;
    .person_grade {
      display: flex;
      align-items: center;
    }
    .person_name {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      .router_edit{
        width: 20px;
        height: 20px;
        margin-left: 4px;
        img{
          width: 20px;
         height: 20px;
        }
      }
    }
    .person_id {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .person_gradebox {
      margin-top: 5px;
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    .person_grade_img {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #721edc;
    }
  }
  .my_person_header {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 12px;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.personal-bottom-bottom-right-bottom-center1 {
  margin-top: 15px;
  border-bottom: 1px #dadada solid;
  .item_pays {
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .titles {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    span {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  .btn_intos {
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    line-height: 28px;
    width: 80px;
    height: 28px;
    background-color: #721edc;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .price_item {
    font-size: 14px;
    color: rgba(213, 213, 213, 1);
  }
  .person_money {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
  }
  .person_money_item {
    margin-bottom: 30px;
    width: 460px;
    height: 60px;
    background: #f7f8fa;
    border-radius: 6px;
    display: flex;
    padding: 0 20px 0 10px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
  }
}
.personal-bottom-bottom-right-bottom-center2 {
  margin-top: 15px;
  width: 100%;
  .userinfo_update {
    display: flex;
    flex-flow: row wrap;
  }
  .number_list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    width: 450px;
    margin-bottom: 30px;
    margin-right: 6%;
  }
  .number_list:nth-child(2n) {
    margin-right: 0 !important;
  }
  .phone_title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .phone_number {
    margin-top: 6px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .phone_img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .update_phone {
    cursor: pointer;
    text-decoration: none;
    width: 130px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    background: rgba(114, 30, 220, 1);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    // color: #666666;
    color: #fff;
  }
  .over_updata {
    color: #666666 !important;
    background: #f7f8fa !important;
  }
  .nophone_item {
    font-size: 16px;
  }
  .number_item {
    display: flex;
    align-items: center;
  }
  .items_tight {
    // margin-left: 14px;
    height: 100%;
  }
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.jingyantiao {
  width: 155px;
  margin: 0 4px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/component/PersonalC.vue